module.exports = __webpack_public_path__ + "static/assets/89cae82d5ad954baef398d4ec81ec023.svg";